import { AnalyticsActions, AnalyticsCategory } from "./types";
import {
  enableSiteImproveTracking,
  siteImproveEvent,
  trackPageviewInSiteImprove,
} from "./siteimprove";
import { useLocation } from "react-router";
import { useEffect, useRef } from "react";

export const analyticsAction = (label: string, category: AnalyticsCategory) =>
  siteImproveEvent({
    action: AnalyticsActions.ACTION,
    category: category,
    label: label,
  });

export function useAnalytics(ready: boolean) {
  useEffect(() => {
    if (ready) {
      enableSiteImproveTracking();
    }
  }, [ready]);
}

export const usePageViewTracker = (): void => {
  const ref = useRef<boolean>(false);
  const location = useLocation();
  const previousTrackedPage = useRef<string>(undefined);
  const newPage = location.pathname + location.hash;

  useEffect(() => {
    if (ref.current) {
      const referrerPath =
        document.referrer === ""
          ? undefined
          : new URL(document.referrer).pathname;
      const pageRef = previousTrackedPage.current ?? referrerPath;

      if (newPage !== pageRef) {
        trackPageviewInSiteImprove(newPage, pageRef);
        previousTrackedPage.current = newPage;
      }
    } else {
      previousTrackedPage.current = newPage;
      ref.current = true;
    }
  }, [newPage, location.hash]);
};
